import React from "react";
import { Grid } from 'semantic-ui-react'
import { InputField, DropDown } from 'KN-EU-Broker-Dashboard-UI'
import RepeatableContainer from "../../commonComponents/form/repeatableFormContainer";
import EntryLineDetailsForm from "./EntryLineDetailsForm";
import EntryLineDetailsRepeatable from "./EntryLineDetailRepeatable";

const EntryLineDetailsTab = () => {
    return (
        <Grid className="responsiveGridCss1 tab-container">
            <RepeatableContainer
                reducerName="entryLineDetail"
                keyName="entryLineDetailTab"
                renderForm={(params) => <EntryLineDetailsRepeatable {...params} />}
            />
        </Grid>
     );
}
 
export default EntryLineDetailsTab;